import React from "react";

import miccaiCertificate from "url:../../miccai_certificate_mahdi_abu_tafish__m1hdi1t@gmail.com.png";

const certifications = [
  {
    title: "MICCAI Summer School",
    issuer: "MICCAI Society",
    learningSummary:
      "Learned practical medical imaging and AI concepts, including how to analyze clinical problems and apply research methods in healthcare ML.",
    downloadUrl: miccaiCertificate,
    downloadName: "miccai_certificate.png",
    downloadLabel: "Download Proof",
  },
  {
    title: "Machine Learning Specialization",
    issuer: "DeepLearning.AI & Stanford Online",
    learningSummary:
      "Built a stronger foundation in supervised learning, model evaluation, and practical ML workflows for real-world problem solving.",
    verifyUrl: "https://www.coursera.org/account/accomplishments/specialization/Y6KEUSZW2LNE",
    verifyLabel: "Show Credential",
  },
  {
    title: "Duolingo English Test",
    issuer: "Score: 120 (B2+)",
    learningSummary:
      "Achieved Upper Intermediate proficiency in English, demonstrating strong professional communication skills.",
  },
];

const Certifications = () => {
  return (
    <section className="padding certifications-section" id="certifications">
      <div className="certifications-header">
        <h2>Certifications</h2>
        <p>
          A snapshot of professional learning milestones and verified credentials.
        </p>
      </div>
      <div className="certifications-grid">
        {certifications.map((certification) => (
          <article className="certification-card" key={certification.title}>
            <h3>{certification.title}</h3>
            <p className="certification-meta">{certification.issuer}</p>
            {certification.learningSummary && (
              <p className="small certification-summary">{certification.learningSummary}</p>
            )}
            <div className="certification-actions">
              {certification.downloadUrl && (
                <a
                  href={certification.downloadUrl}
                  className="project-action-button"
                  download={certification.downloadName}
                >
                  {certification.downloadLabel || "Download Certificate"}
                </a>
              )}
              {certification.verifyUrl && (
                <a
                  href={certification.verifyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-action-button"
                >
                  {certification.verifyLabel || "Verify Credential"}
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Certifications;
